import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosComparativasuanominaListaItemValidacion {
  valido
  mensaje
  etiqueta
}

module.component('recursoshumanosComparativasuanominaListaItemValidacion', {
  controller: RecursoshumanosComparativasuanominaListaItemValidacion,
  template,
  bindings: {
    valido: '<',
    mensaje: '<',
    etiqueta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/comparativaSuaNomina/lista/item/validacion/component.js